const VirtualScroll = require('../../vendor/VirtualScroll')

import { GetBy } from '../core/Element';
import { Maths } from '../utils/Maths';
import InfiniteScroll__Item from './InfiniteScroll__Item';
import { Metrics } from '../core/Metrics';
import { Interaction, MrInteraction } from '../core/Interaction';

export default class InfiniteScroll {
    static AXIS_X = 'X';
    static AXIS_Y = 'Y';
    static _uid = 0;

    scroller;
    direction = 1;

    position = 0;
    target = 0;
    speed = 0;
    total_items = 0;
    tick = 0;

    id;
    width;
    height;
    options;

    _container;
    _items = [];

    _enabled = false;
    _isShow = false;

    _axis = 'y';
    _measure = 'height';
    _domAxis = 'top';
    _offsetAxis = 'offsetTop';
    _offsetSize = 'offsetHeight';

    _call;
    _idPrev;
    _idNext;

    _threshold = {
        min: 0,
        max: 0
    }

    //
    // GETTER & SETTER
    //
    get enabled() { return this._enabled; };
    set enabled(__isEnabled) {
        if (this._enabled !== __isEnabled) {
            this._enabled = __isEnabled;

            if (this.scroller) {
                if (__isEnabled) {
                    this.scroller.on(this._call);
                } else {
                    this.scroller.off(this._call);
                }
            }
        }
    };

    constructor(__axis, opts = {}) {
        this.id = `InfiniteScroll-${++InfiniteScroll._uid}`;
        this._container = opts.container || document.body;
        this._appendContainer = opts.appendContainer || this._container;
        this.width = this._container.offsetWidth;
        this.height = this._container.offsetHeight;

        this._hasCustomOffset = opts.offset != null;

        this.options = {
            axis: __axis || 'Y',
            smooth: opts.smooth || false,
            easing: opts.easing || 0.08,
            maxSpeed: opts.maxSpeed || 400,
            multiplicator: opts.multiplicator || 1,
            itemClass: opts.itemClass || InfiniteScroll__Item,
            offset: this._hasCustomOffset ? opts.offset : 100,
            inverted: opts.inverted || false,
            hasVirtuaScroll: opts.hasVirtuaScroll === false ? false : true,
            hasInteraction: opts.hasInteraction,
            gap: opts.gap || 0, // Agregamos el gap como una opción
            minSpeed: opts.minSpeed || 0
        };

        if (this.options.hasVirtuaScroll) {
            this.scroller = new VirtualScroll({
                mouseMultiplier: navigator.platform.indexOf('Win') > -1 ? 1 : 0.5,
                firefoxMultiplier: 50,
                touchMultiplier: 3.5,
                passive: true
            });

            this._call = (e) => { this.check(e) };
        }

        if (this.options.hasInteraction) {
            this._interaction = new MrInteraction(this._container, {
                drag: true,
                axis: 'x',
                dragCheckTime: .05,
                onMove: (n) => {
                if (this.options.onMove) options.onMove();
                this.move(n)
                },
                onDragStart: () => {
                if (this.options.onDragStart) options.onDragStart();
                },
                onDragEnd: () => {
                if (this.options.onDragEnd) options.onDragEnd();
                }
            });
        }

        this._container.classList.add('__vscroll-inifinity');

        switch (this.options.axis) {
            case InfiniteScroll.AXIS_Y:
                this._container.classList.add('__scroll-infinity-axis-y');
                this._axis = 'y';
                this._measure = 'height';
                this._domAxis = 'top';
                this._offsetAxis = 'offsetTop';
                this._offsetSize = 'offsetHeight';
                break;

            case InfiniteScroll.AXIS_X:
                this._container.classList.add('__scroll-infinity-axis-x');
                this._axis = 'x';
                this._measure = 'width';
                this._domAxis = 'left';
                this._offsetAxis = 'offsetLeft';
                this._offsetSize = 'offsetWidth';
                break;
        }

        this.setupResize(opts.domResize || this._container);
        this.addAll(opts.selector);
        this._setupControls();
    }

    _setupControls() {
        this._idPrev = `${this.id}-prev`;
        this._idNext = `${this.id}-next`;

        Interaction.addListener('data-prev', (e) => {
            console.log(this._container);

            if (!this._container.contains(e.target)) return;
            e.event.preventDefault();
            this.goToPrev();
        }, this._idPrev);

        Interaction.addListener('data-next', (e) => {
            if (!this._container.contains(e.target)) return;
            e.event.preventDefault();
            this.goToNext();
        }, this._idNext);
    }

    getStep() {
        return (this._baseSize || 0) + (this._gap || 0);
    }

    getCurrentIndex() {
        const step = this.getStep();
        if (!step) return 0;
        return Math.round(-this.position / step);
    }

    goToIndex(__index) {
        const step = this.getStep();
        if (!step) return;

        const targetPos = -__index * step;
        const multiplicator = this.options.multiplicator || 1;
        const delta = this.options.inverted
            ? (this.target - targetPos) / multiplicator
            : (targetPos - this.target) / multiplicator;

        this.move(delta);
    }

    goToNext() {
        this.goToIndex(this.getCurrentIndex() + 1);
    }

    goToPrev() {
        this.goToIndex(this.getCurrentIndex() - 1);
    }

    addAll(__selector = '[scroll-infinity-item]') {
        const items = GetBy.selector(__selector, this._container);
        for (let i = 0; i < items.length; i++) {
            const item = new this.options.itemClass(items[i], i, this._axis == 'y' ? InfiniteScroll.AXIS_Y : InfiniteScroll.AXIS_X, true, this);
            this.total_items = this._items.push(item);
        }

        this._threshold.max = this.total_items;
    }

    setupResize(__dom) {
        this.resizeObserver = new ResizeObserver(entries => {
            this.resize();
        });

        this.resizeObserver.observe(__dom);
    }

    //
    // PUBLIC
    //
    start() {
        this.enabled = true;
    }

    show() {
        if (!this._isShow) {
            this.loop(true);
            this._isShow = true;
        }
    }

    hide() {
        this.enabled = false;
        this._container.classList.remove('__vscroll-inifinity');
        this._container.classList.remove('__scroll-infinity-axis-y');
        this._container.classList.remove('__scroll-infinity-axis-x');
    }

    move(n) {
        this.check({deltaY:n});
    }

    check(e, __direct) {
        if (__direct) e = { deltaY: __direct }
        const d = Maths.precission(e.deltaY * this.options.multiplicator, 2);

        if (d > 0) {
            /*LogoGlitch.showSmile();
            LogoGlitch.startBasic();*/
            // this.options.inverted = true;

        } else {
            this.options.inverted = false;
        }

        if (this.options.inverted) {
            this.target -= d;
            this.direction = e.deltaY >= 0 ? 1 : -1
        } else {
            this.target += d;
            this.direction = e.deltaY < 0 ? 1 : -1;
        }

        this.checkHook(e);
        this._container.parentNode.style.setProperty('--direction', this.direction == 1 ? 0 : 1);
    }

    checkHook() { }

    loop(__force = false) {
        if (!this.enabled) return;

        this.tick = this.tick + 1;
        this.target = this.target - this.options.minSpeed;
        if (Maths.precission(this.target) !== Maths.precission(this.position) || __force) {
            this.calcSpeed();
            this.updateItemsPosition();
            this.checkItemsReorder(__force);
        }
    }

    _recycleItem(__item) {
        __item.place(this._baseSize, this._gap, false);
        __item.resizeLimits();
        __item[this._axis] = this.position;
    }

    checkItemsReorder(__force = false) {
        const offset = this.options.offset;
        const view = this[this._measure];
        const goingStart = this.speed < 0 || (__force && this.speed >= 0);
        let guard = Math.max(this.total_items * 4, 4);

        if (goingStart) {
            while (guard--) {
                let wrapped = false;
                for (let i = 0; i < this.total_items; i++) {
                    const item = this._items[i];
                    const itemEnd = item[this._axis] + item[this._domAxis] + item[this._measure];

                    if (itemEnd < -offset) {
                        item.index = this._threshold.max;
                        this._threshold.min++;
                        this._threshold.max++;
                        this._recycleItem(item);
                        wrapped = true;
                    }
                }
                if (!wrapped) break;
            }
        } else {
            while (guard--) {
                let wrapped = false;
                for (let i = this.total_items - 1; i >= 0; i--) {
                    const item = this._items[i];
                    const itemStart = item[this._axis] + item[this._domAxis];

                    if (itemStart > view + offset) {
                        this._threshold.min--;
                        this._threshold.max--;
                        item.index = this._threshold.min;
                        this._recycleItem(item);
                        wrapped = true;
                    }
                }
                if (!wrapped) break;
            }
        }
    }

    calcSpeed() {
        this.speed = (this.target - this.position) * this.options.easing;

        if (this.speed === 0) this.position = this.target;
        else this.position += this.speed;
    }

    updateItemsPosition() {
        for (let i = 0; i < this.total_items; i++) {
            this._items[i].tick = this.tick;
            this._items[i][this._axis] = this.position;
            this._items[i].speed = this.speed;
            const dir = this.options.inverted ? this.direction * -1 : this.direction;
            this._items[i].direction = dir;
        }
    }

    placeItems() {
        for (let i = 0; i < this.total_items; i++) {
            this._items[i].place(this._baseSize, this._gap);
        }
    }

    resize() {
        this.width = this._container.offsetWidth;
        this.height = this._container.offsetHeight;

        if (this._isShow) this.loop(true);

        for (let i = 0; i < this.total_items; i++) {
            this._items[i].resize(this._appendContainer[this._offsetSize]);
        }

        if (this.total_items > 0) this._baseSize = this._items[0][this._measure];
        else this._baseSize = 0;

        this._gap = Metrics.parseSize(this.options.gap + 'fpx');

        // Default recycle margin scales with track length (Team / News).
        // Custom offset (Reports) is kept as-is so short tracks can still wrap off-screen.
        if (!this._hasCustomOffset && this._baseSize) {
            this.options.offset = this._baseSize * this.total_items * 0.35;
        }

        this.placeItems();
        this.checkItemsReorder(true);
        this.updateItemsPosition();
    }

    dispose() {
        this.enabled = false;

        Interaction.removeListener(this._idPrev);
        Interaction.removeListener(this._idNext);

        for (let i = 0; i < this.total_items; i++) this._items[i].dispose();

        this.total_items = 0;
        this._items = [];

        if (this.scroller) {
            this.scroller.destroy();
        }

        this.resizeObserver.disconnect();
    }
}
